var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firePower"},[_vm._v(" 消防电源 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }